module.exports = __webpack_public_path__ + "img/51626524_L.03e1c14e.png";